"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const map_1 = __importDefault(require("lodash/map"));
const size_1 = __importDefault(require("lodash/size"));
const mobx_1 = require("mobx");
const getCorporatePartnerList_1 = __importDefault(require("../clients/promo/getCorporatePartnerList"));
const API_STATE_1 = __importDefault(require("../constants/app/API_STATE"));
const corporatePartnerListFactory_1 = __importDefault(require("../factories/corporatePartnerList/corporatePartnerListFactory"));
const getCorporatePartnerListNotFound_1 = __importDefault(require("../utils/error/getCorporatePartnerListNotFound"));
const mapInitialStateToStoreState_1 = __importDefault(require("../utils/store/mapInitialStateToStoreState"));
/**
 * Corporate Partner List Domain Store
 * Stores a list of Corporate Promo Codes.
 */
class CorporatePartnerListStore {
    constructor(initialState, $env) {
        this.data = [];
        this.selectedPartner = {};
        this.apiState = API_STATE_1.default.INITIAL;
        this.errorData = {};
        /**
         * Fetch Corporeate partner list data from backend
         * @param {string} quoteId
         * @param errorHandler { function}
         */
        this.fetch = (0, mobx_1.flow)(function* (quoteId = '', errorHandler) {
            try {
                this.apiState = API_STATE_1.default.LOADING;
                this.data = [];
                this.errorData = {};
                // make the api call
                const promoListResponse = yield (0, getCorporatePartnerList_1.default)(quoteId);
                const data = (0, get_1.default)(promoListResponse, 'data', []);
                const total = (0, get_1.default)(promoListResponse, 'total', 0);
                // for no data (0) response comes back with only total
                if (total < 1) {
                    // throw custom error
                    const errObj = (0, getCorporatePartnerListNotFound_1.default)();
                    this.onError(errObj, errorHandler);
                }
                else {
                    this.onSuccess(data);
                }
            }
            catch (err) {
                this.onError(err, errorHandler);
            }
        });
        /**
         * on success callback
         * @param {Array<CorporatePartnerListType>} data
         */
        this.onSuccess = (data) => {
            this.data = data;
            this.apiState = API_STATE_1.default.SUCCESS;
        };
        /**
         * on error callback
         * @param {AxiosError} err
         * @param {ErrorHandlerType} errorHandler
         */
        this.onError = (err, errorHandler) => {
            this.apiState = API_STATE_1.default.FAILED;
            if (err.response) {
                const errResponse = err.response;
                const { data, status } = errResponse;
                // stores axios error info in observable
                this.errorData = {
                    data,
                    status,
                };
                if (errorHandler) {
                    errorHandler(errResponse);
                }
            }
        };
        /**
         * setSelectedPartner by cdpPartner
         * @param {SelectedPartnerType} cdpPartner
         */
        this.setSelectedPartner = (cdpPartner) => {
            this.selectedPartner = Object.assign({}, cdpPartner);
        };
        /**
         * Map initial state to store state
         * @param {InitialStateStoreType<CorporatePartnerListType>} initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.$env = $env;
        this.updateInitialState(initialState);
    }
    /**
     * Returns the loading status
     * @returns {Boolean}
     */
    get isLoading() {
        return this.apiState === API_STATE_1.default.LOADING;
    }
    /**
     * Returns if API fetch was success
     * @returns {Boolean}
     */
    get isSuccess() {
        return this.apiState === API_STATE_1.default.SUCCESS;
    }
    /**
     * Returns if API fetch has failed
     * @returns {Boolean}
     */
    get hasFailed() {
        return this.apiState === API_STATE_1.default.FAILED;
    }
    /**
     * Returns true if API fetch returned no data
     * @returns {Boolean}
     */
    get hasNoData() {
        return this.isSuccess && this.count === 0;
    }
    /**
     * Returns total promo count
     * @returns {Number}
     */
    get count() {
        return (0, size_1.default)(this.corporatePartnerList);
    }
    /**
     * Returns current config language
     * @returns {Boolean}
     */
    get language() {
        return this.$env.config.locale;
    }
    /**
     * Returns formatted corporate partner List
     * @returns {Array<CorporatePartnerListFactoryType>}
     */
    get corporatePartnerList() {
        return (0, map_1.default)(this.data, (promoInfo) => (0, corporatePartnerListFactory_1.default)(promoInfo));
    }
}
__decorate([
    mobx_1.observable
], CorporatePartnerListStore.prototype, "data", void 0);
__decorate([
    mobx_1.observable
    // eslint-disable-next-line prettier/prettier
], CorporatePartnerListStore.prototype, "selectedPartner", void 0);
__decorate([
    mobx_1.observable
], CorporatePartnerListStore.prototype, "apiState", void 0);
__decorate([
    mobx_1.observable
], CorporatePartnerListStore.prototype, "errorData", void 0);
__decorate([
    mobx_1.computed
], CorporatePartnerListStore.prototype, "isLoading", null);
__decorate([
    mobx_1.computed
], CorporatePartnerListStore.prototype, "isSuccess", null);
__decorate([
    mobx_1.computed
], CorporatePartnerListStore.prototype, "hasFailed", null);
__decorate([
    mobx_1.computed
], CorporatePartnerListStore.prototype, "hasNoData", null);
__decorate([
    mobx_1.computed
], CorporatePartnerListStore.prototype, "count", null);
__decorate([
    mobx_1.computed
], CorporatePartnerListStore.prototype, "language", null);
__decorate([
    mobx_1.computed
], CorporatePartnerListStore.prototype, "corporatePartnerList", null);
__decorate([
    mobx_1.action.bound
], CorporatePartnerListStore.prototype, "onSuccess", void 0);
__decorate([
    mobx_1.action.bound
], CorporatePartnerListStore.prototype, "onError", void 0);
__decorate([
    mobx_1.action.bound
], CorporatePartnerListStore.prototype, "setSelectedPartner", void 0);
exports.default = CorporatePartnerListStore;
